import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Customer } from '../../../feature/customer/dto/customer';
import { Vessel } from '../../../feature/vessel/dto/vessel';
import { Trail } from '../../../feature/trail/dto/trail';
import { Test } from '../../../feature/test/dto/test';
import { TestStep } from '../../../feature/test-step/dto/test-step';
import { Recommendation } from '../../../feature/recommendation/dto/recommendation';
import { StepRecom } from '../../../feature/step-recom/interface/step-recom';

@Injectable({
  providedIn: 'root'
})
export class StateNotifyService {

  constructor() { }

  // ------ Login -------

  private isLogin = new BehaviorSubject<boolean>(false);
  loginState$ = this.isLogin.asObservable();

  updateLoginState(state: boolean) {
    this.isLogin.next(state);
  }

  getLoginState() {
    return this.isLogin.value;
  }

  // ------ Customer -------

  // declare and initialize the property which will be a BehaviorSubject
  private selectedCustomer = new BehaviorSubject<Customer>({ id: 0, name: 'Customer...' });
  // expose the BehaviorSubject as an Observable
  customerSelection$ = this.selectedCustomer.asObservable();

  private listAllCustomers = new BehaviorSubject<Customer[]>([]);
  allCustomersList$ = this.listAllCustomers.asObservable();

  // function to update the value of the BehaviorSubject
  updateCustomerSelection(newSelection: Customer) {
    this.selectedCustomer.next(newSelection);
  }
  updateAllCustomerList(list: Customer[]) {
    this.listAllCustomers.next(list);
  }

  // function to query the current state
  getSelectedCustomer() {
    return this.selectedCustomer.value;
  }
  getListAllCustomers() {
    return this.listAllCustomers.value;
  }

  // ------ Vessel -------

  private selectedVessel = new BehaviorSubject<Vessel>({ id: 0, name: 'Vessel...', customer_id: 0 });
  vesselSelection$ = this.selectedVessel.asObservable();
  private listAllVessels = new BehaviorSubject<Vessel[]>([]);
  allVesselsList$ = this.listAllVessels.asObservable();

  updateVesselSelection(vessel: Vessel) {
    this.selectedVessel.next(vessel);
    console.log("Notify: " + vessel.name);
  }
  updateListAllVessels(listAllVessels: Vessel[]) {
    this.listAllVessels.next(listAllVessels);
  }
  getSelectedVessel() {
    return this.selectedVessel.value;
  }
  getListAllVessels() {
    return this.listAllVessels.value;
  }

  // ------ Trail -------

  private selectedTrail = new BehaviorSubject<Trail>({ id: 0, vessel_id: 0, name: 'Trail...', });
  trailSelection$ = this.selectedTrail.asObservable();
  private listAllTrails = new BehaviorSubject<Trail[]>([]);
  allTrailsList$ = this.listAllTrails.asObservable();

  updateTrailSelection(trail: Trail) {
    this.selectedTrail.next(trail);
    console.log("Notify: " + trail.name);
  }
  updateListAllTrails(listAllTrails: Trail[]) {
    this.listAllTrails.next(listAllTrails);
  }
  getSelectedTrail() {
    return this.selectedTrail.value;
  }
  getListAllTrails() {
    return this.listAllTrails.value;
  }

  // ------ Test -------

  private selectedTest = new BehaviorSubject<Test>({ id: 0, trail_id: 0, vessel_id: 0, sn: '0', name: 'Trail...', });
  testSelection$ = this.selectedTest.asObservable();
  private listAllTests = new BehaviorSubject<Test[]>([]);
  allTestsList$ = this.listAllTests.asObservable();

  updateTestSelection(test: Test) {
    this.selectedTest.next(test);
  }
  updateListAllTests(list: Test[]) {
    this.listAllTests.next(list);
  }

  getSelectedTest() {
    return this.selectedTest.value;
  }
  getListAllTests() {
    return this.listAllTests.value;
  }

  // ------ Test step-------

  private selectedTestStep = new BehaviorSubject<TestStep>({ id: 0, test_id: 0, sn: '0', });
  testStepSelection$ = this.selectedTestStep.asObservable();
  private listAllTestStep = new BehaviorSubject<TestStep[]>([]);
  allTestStepList$ = this.listAllTestStep.asObservable();

  updateTestStepSelection(testStep: TestStep) {
    this.selectedTestStep.next(testStep);
  }
  updateListAllTestStep(list: TestStep[]) {
    this.listAllTestStep.next(list);
  }

  getSelectedTestStep() {
    return this.selectedTestStep.value;
  }
  getListAllTestStep() {
    return this.listAllTestStep.value;
  }

  // ------ Recommendation-------

  private selectedRecommendation = new BehaviorSubject<Recommendation>({ id: 0, test_id: 0, sn: '0', });
  recommendationSelection$ = this.selectedRecommendation.asObservable();
  private listAllRecommendation = new BehaviorSubject<Recommendation[]>([]);
  allRecommendationList$ = this.listAllRecommendation.asObservable();

  updateRecommendationSelection(recommendation: Recommendation) {
    this.selectedRecommendation.next(recommendation);
  }
  updateListAllRecommendation(list: Recommendation[]) {
    this.listAllRecommendation.next(list);
  }

  getSelectedRecommendation() {
    return this.selectedRecommendation.value;
  }
  getListAllRecommendation() {
    return this.listAllRecommendation.value;
  }

    // ------ Step Recommendation -------

  private selectedStepRecom = new BehaviorSubject<StepRecom>({ id: 0, test_step_id: 0, sn: '0', });
  stepRecomSelection$ = this.selectedStepRecom.asObservable();
  private listAllStepRecom = new BehaviorSubject<StepRecom[]>([]);
  allStepRecomList$ = this.listAllStepRecom.asObservable();

  updateStepRecomSelection(stepRecom: StepRecom) {
    this.selectedStepRecom.next(stepRecom);
  }
  updateListAllStepRecom(list: StepRecom[]) {
    this.listAllStepRecom.next(list);
  }

  getSelectedStepRecom() {
    return this.selectedStepRecom.value;
  }
  getListAllStepRecom() {
    return this.listAllStepRecom.value;
  }

  // ------ Edit Right ------
  
  private isWithEditRight = new BehaviorSubject<boolean>(false);
  hasEditRight$ = this.isWithEditRight.asObservable();

  updateUserEditRight(editRight: boolean) {
    this.isWithEditRight.next(editRight);
  }

  getUserEditRight() {
    return this.isWithEditRight.value;
  }

  // ------ Readonly or edit mode ------

  private isReadonly = new BehaviorSubject<boolean>(true);
  readonlyMode$ = this.isReadonly.asObservable();

  updateReadonlyMode(mode: boolean) {
    this.isReadonly.next(mode);
  }

  getReadonlyMode() {
    return this.isReadonly.value;
  }

  // ------ model display mode ------

  private displayMode = new BehaviorSubject<number>(0);
  currentDisplayMode$ = this.displayMode.asObservable();

  updateDisplayMode(mode: number) {
    this.displayMode.next(mode);
  }

  getDisplayMode() {
    return this.displayMode.value;
  }

}
